import { columnsRetire } from 'utils/columns-table';

import {
  StyledTableRow,
  StyledTableCell,
  StyledTableHead,
  StyledTableTitle
} from './retire-table.style';

export const TableHead = ({ className = 'default' }) => {
  return (
    <StyledTableHead>
      <StyledTableRow className={`mode-${className}`}>
        {columnsRetire.map(({ title, dataIndex }) => (
          <StyledTableCell key={dataIndex}>
            <StyledTableTitle>{title}</StyledTableTitle>
          </StyledTableCell>
        ))}
      </StyledTableRow>
    </StyledTableHead>
  );
};
